export default "__VITE_ASSET__BnJX9gae__"